import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { FormQuestion } from '../dynamic/model/FormQuestion';
import { Form } from '../dynamic/model/Form';

@Component({
    selector: 'app-declaration-question',
    templateUrl: './declarationQuestion.component.html',
    styleUrls: ['./declarationQuestion.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DeclarationQuestionComponent {
  @Input() question!: FormQuestion;
  @Input() form!: Form;
  @Input() readonly = false;
  @Input() formId!: string;
}
